import { useGetDownloadSignedUrlForTaskQuestionLazyQuery } from '@exam-management/graphql';

import type { Question } from '../../types';
import { mapImageContentForQuestion, getQuestionFileNames } from '../../utils';

interface UseGetSingleQuestionWithImageProps {
  questionId: string;
  taskId: string;
}

export function useGetSingleQuestionWithImage(props: Readonly<UseGetSingleQuestionWithImageProps>) {
  const { questionId, taskId } = props;

  const [getDownloadSignedUrlForTaskQuestion, { loading: isGettingDownloadSignedUrlForQuestions }] =
    useGetDownloadSignedUrlForTaskQuestionLazyQuery();

  const getSignedUrl = async (fileNames: string[]) => {
    const questionContentMapResult = await getDownloadSignedUrlForTaskQuestion({
      variables: {
        input: {
          questionId,
          fileNames,
        },
        taskId,
      },
    });

    return questionContentMapResult.data?.qctGetDownloadSignedUrlForTaskQuestion.signedUrls;
  };

  const getSingleQuestionWithImage = async (question: Question) => {
    const { questionFileNames } = getQuestionFileNames(question);

    const questionAssetMap: Record<string, string> = await getSignedUrl(questionFileNames);

    return mapImageContentForQuestion(question, questionAssetMap);
  };

  return {
    getSingleQuestionWithImage,
    loading: isGettingDownloadSignedUrlForQuestions,
  };
}
